import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { HttpService, CommonService } from '../../../services';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-file-drop-zone',
  templateUrl: './file-drop-zone.component.html',
  styleUrls: ['./file-drop-zone.component.css']
})
export class FileDropZoneComponent implements OnInit, OnChanges {

  @Input() config: DropzoneConfigInterface;
  @Input() disabled: boolean;
  @Input() disableUpload: boolean;
  @Input() text = 'Drop new file here to upload';
  @Input() limit = 1.5;
  @Output() upload = new EventEmitter();
  @Output() fileChange = new EventEmitter();
  @Input() isOpendPlayer: boolean;
  file: any;
  uploading: boolean;

  constructor(
    private httpService: HttpService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    if (this.isOpendPlayer) {
      this.file = null;
    }
  }

  clear() {
    this.file = null;
  }

  ngOnChanges(data) {
    if (data.config) {
      this.config = {
        ...{
          url: '',
          acceptedFiles: 'application/pdf,image/png,image/jpeg',
          uploadMultiple: false,
          autoProcessQueue: false,
          autoQueue: false,
          previewsContainer: false,
          clickable: true,
          maxFilesize: 1, // MB
          parallelUploads: 1
        },
        ...this.config
      };
    }
  }

  onUploadSuccess(event) {
    // console.log('success', event);
  }

  onUploadError(event) {
    // console.log('onUploadError', event);
  }

  onComplete(event) {
    // console.log('onComplete', event);
  }

  onAdd(event) {
    if (this.limit && event.size > this.limit * 1024 * 1024) {
      this.commonService.alertMessage({ type: 'error', message: `HEADS UP! The file you are uploading is too large in size. Please reduce the size to be below 1.5mb.`});
      return;
    }

    this.fileChange.emit(event);

    if (!this.disableUpload) {
      this.disabled = true;
      this.uploading = true;

      const fileToUpload = event;
      const fileName = event.name;

      this.httpService.upload(this.config.url as string, fileToUpload, fileName).pipe(finalize(() => {
        this.disabled = false;
        this.uploading = false;
      })).subscribe(
        res => {
          this.upload.emit(res[0]);
          this.file = res[0];
        }
      );
    } else {
      this.text = event.name;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/file-drop-zone/file-drop-zone.component.ts